import React from "react";

const ComparisonRowButton = ({products, label, callback, cssClassNames}) => {
    return (
        <div className="row">
            <div>&nbsp;</div>
            {products.map(product => (
                <button type="button" key={product.id} className={cssClassNames + " comparison-action-button"} onClick={() => callback(product.id)}>
                    <span className="lfr-btn-label">{label}</span>
                </button>
            ))}
        </div>
    )
}
export default ComparisonRowButton;